import { TranslationService } from "projects/dop-core/src/public-api";

export const DEFAULTSAMPLENAME = TranslationService.translate('vbeiNewSample');
export const TOTALSAMPLECOUNT = 300;
export const DEFAULTSAMPLECOUNT = 5;
export const MAXSAMPLEMESSAGE = TranslationService.translate('vbeiMaxSamplesCopied');
export const MAXIMUMSAMPLEERROR = TranslationService.translate('vbeiAddMoreSamples');
export const CUSTOMER_REFERENCE = 'customerReference';
export const CODE = 'code';
export const VALUE = 'value';
export const ISUNIQUE = 'isUnique';
export const SAMPLE_CODE = 'sampleCode';
export const ISMANDATORY = 'isMandatory';
export const DESCRIPTION = 'description';
export const COMMENT = 'comment';
export const LOTNUMBER = 'lotNumber';
export const AFS = 'afs';
export const SAMPLES = 'samples';
export const PRIORITYLEVEL = 'priorityLevel';
export const Top = 'Top';
export const Standard = 'Standard';
export const Rush = 'Rush';
export const STD = 'STD';
export const RUSH = 'RUSH2';
export const TOPPRIORITY = 'RUSH3';
export const ANALYTICALREPORTGROUPINGRULE = 'analyticalReportGroupingRule';
export const STANDARDORDERPRIORITYDAYS = '7';
export const INVALIDDATE = TranslationService.translate('vbeiInvalidDate');
export const SERVINGSIZE = 'servingSize';
export const SERVINGUNIT = 'servingUnit';
export const SERVINGUNITNUMERATORCODE = 'servingUnitNumeratorCode';
export const SERVINGUNITNUMERATORNAME = 'servingUnitNumeratorName';
export const SERVINGUNITDENOMINATORCODE = 'servingUnitDenominatorCode';
export const SERVINGUNITDENOMINATORNAME = 'servingUnitDenominatorName';
export const ORDER = 'Order';
export const SAMPLE = 'Sample';
export const PRODUCTCODE = 'productCode';
export const RUSH2 = 'RUSH 2X';
export const RUSH3 = 'RUSH 3X';
export const LABSITE = 'Labsite';
export const ORDERINGSERVICE = 'Ordering Service';
export const MINSAMPLENAMECHARACTERLIMIT = 0;
export const MAXSAMPLENAMECHARACTERLIMIT = 50;
